import { render, staticRenderFns } from "./RegisterFeeModal.vue?vue&type=template&id=10e60fae&lang=pug"
import script from "./RegisterFeeModal.vue?vue&type=script&lang=js"
export * from "./RegisterFeeModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterFeeModal.vue?vue&type=style&index=0&id=10e60fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports